export class ERP {
    public id: number | null;
    public company_id: number;
    public createdAt: Date | null;

    constructor(data: ERPData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.company_id = 0;
            this.createdAt = null;

        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.createdAt = null;
            if (data.createdAt !== null) {
                this.createdAt = new Date(data.createdAt);
            }
        }
    }
}

export type ERPData = {
    id: number | null;
    company_id: number;
    createdAt: Date | null;
}
